var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2450 4251 c-447 -183 -2060 -865 -2080 -879 -14 -11 -32 -38 -40 -60 -13 -37 -13 -47 0 -84 8 -22 26 -49 40 -60 14 -10 500 -219 1080 -464 797 -337 1067 -447 1105 -451 47 -4 97 16 898 355 l847 359 0 -527 0 -528 -30 -12 c-108 -45 -174 -261 -121 -399 l18 -49 -58 -263 c-33 -144 -59 -273 -59 -286 0 -29 42 -73 69 -73 11 0 52 17 92 37 62 33 83 38 151 42 83 3 144 -12 200 -51 14 -10 40 -21 57 -24 25 -5 36 -1 61 24 16 17 30 37 30 45 0 8 -34 136 -76 283 l-76 268 16 46 c10 27 16 76 16 122 0 102 -28 178 -86 237 l-44 44 0 566 0 566 140 59 c148 62 182 87 195 146 10 44 -3 86 -34 118 -27 26 -137 73 -1844 794 -180 76 -338 138 -350 138 -12 0 -65 -18 -117 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202 2208 c3 -411 4 -424 25 -463 29 -54 62 -83 168 -150 244 -154 545 -263 855 -312 157 -24 461 -24 620 1 249 39 479 110 690 216 229 114 306 171 346 255 l24 50 0 414 c0 389 -1 413 -17 408 -10 -2 -297 -123 -638 -268 l-620 -264 -90 0 -90 0 -629 268 c-346 147 -633 267 -638 267 -5 0 -8 -184 -6 -422z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.b1051b0724117416736e4e5601dcaffd.svg";
export { ForwardRef as ReactComponent };